import { render, staticRenderFns } from "./split-collection-records.vue?vue&type=template&id=479091b9&scoped=true&"
import script from "./split-collection-records.vue?vue&type=script&lang=js&"
export * from "./split-collection-records.vue?vue&type=script&lang=js&"
import style0 from "./split-collection-records.vue?vue&type=style&index=0&id=479091b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479091b9",
  null
  
)

export default component.exports